window.sectionRenderers = window.sectionRenderers || {};

window.sectionRenderers.fullWidthVideo = function (data) {
  if (!data.videoUrl) return "";
  const speakerIconUrl = (window.csIconUrls && window.csIconUrls.speaker) || "";
  const muteIconUrl = (window.csIconUrls && window.csIconUrls.mute) || "";
  const fullScreenIconUrl =
    (window.csIconUrls && window.csIconUrls.fullScreen) || "";
  return (
    '<div class="cs-full-width">' +
    '<div class="cs-full-width__media" onclick="toggleCsVideoFromMedia(event)">' +
    '<video src="' +
    escapeHtml(data.videoUrl) +
    '" loop muted playsinline preload="metadata" onloadedmetadata="csVideoShowFirstFrame(this)"></video>' +
    '<div class="cs-full-width__controls">' +
    '<button type="button" class="cs-full-width__mute" aria-label="Toggle mute" onclick="toggleCsVideoMute(this)">' +
    '<img class="cs-speaker-icon" src="' +
    escapeHtml(speakerIconUrl) +
    '" alt="" style="display:none">' +
    '<img class="cs-mute-icon" src="' +
    escapeHtml(muteIconUrl) +
    '" alt="">' +
    "</button>" +
    '<button type="button" class="cs-full-width__fullscreen" aria-label="Toggle full screen" onclick="toggleCsVideoFullscreen(this)">' +
    '<img class="cs-fullscreen-icon" src="' +
    escapeHtml(fullScreenIconUrl) +
    '" alt="">' +
    "</button>" +
    "</div>" +
    '<div class="cs-full-width__play" onclick="event.stopPropagation(); toggleCsVideo(this)"><svg class="cs-play-icon" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg><svg class="cs-pause-icon" viewBox="0 0 24 24" fill="white" style="display:none"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg></div>' +
    (data.title
      ? '<h3 class="cs-full-width__title">' + escapeHtml(data.title) + "</h3>"
      : "") +
    "</div>" +
    "</div>"
  );
};

function toggleCsVideoMute(button) {
  const media =
    button.closest(".cs-full-width__media") ||
    button.closest(".cs-media-text__media");
  if (!media) return;
  const video = media.querySelector("video");
  if (!video) return;
  video.muted = !video.muted;
  button.querySelector(".cs-speaker-icon").style.display = video.muted
    ? "none"
    : "block";
  button.querySelector(".cs-mute-icon").style.display = video.muted
    ? "block"
    : "none";
}

function csVideoShowFirstFrame(video) {
  // iOS Safari leaves the video black until played; nudge currentTime so the
  // first frame is decoded and painted as the poster.
  try {
    if (video.currentTime === 0) video.currentTime = 0.001;
  } catch (e) {}
}

function toggleCsVideoFullscreen(button) {
  const media =
    button.closest(".cs-full-width__media") ||
    button.closest(".cs-media-text__media");
  if (!media) return;
  const video = media.querySelector("video");

  if (document.fullscreenElement) {
    document.exitFullscreen();
    return;
  }

  // iOS Safari only allows fullscreen on the video element itself
  if (video && typeof video.webkitEnterFullscreen === "function") {
    video.webkitEnterFullscreen();
    return;
  }

  if (media.requestFullscreen) {
    media.requestFullscreen();
  } else if (media.webkitRequestFullscreen) {
    media.webkitRequestFullscreen();
  }
}

function toggleCsVideoFromMedia(event) {
  // Click-anywhere toggling is for wider viewports only. On mobile (≤760px)
  // a tap reveals controls (via --touched), so toggling there fights the UX.
  if (window.matchMedia("(max-width: 760px)").matches) return;
  // Ignore clicks on the mute / fullscreen buttons; let their handlers run.
  if (event.target.closest("button")) return;
  const media = event.currentTarget;
  const playButton = media.querySelector(
    ".cs-full-width__play, .cs-media-text__play",
  );
  if (!playButton) return;
  toggleCsVideo(playButton);
}

function toggleCsVideo(button) {
  const media =
    button.closest(".cs-full-width__media") ||
    button.closest(".cs-media-text__media");
  if (!media) return;
  const video = media.querySelector("video");
  if (!video) return;
  const playIcon = button.querySelector(".cs-play-icon");
  const pauseIcon = button.querySelector(".cs-pause-icon");
  if (video.paused) {
    video.play();
    media.classList.add(
      media.classList.contains("cs-full-width__media")
        ? "cs-full-width__media--playing"
        : "cs-media-text__media--playing",
    );
    if (playIcon) playIcon.style.display = "none";
    if (pauseIcon) pauseIcon.style.display = "block";
  } else {
    video.pause();
    media.classList.remove(
      "cs-full-width__media--playing",
      "cs-media-text__media--playing",
    );
    if (playIcon) playIcon.style.display = "block";
    if (pauseIcon) pauseIcon.style.display = "none";
  }
}

const CS_TOUCH_HIDE_DELAY_MS = 2000;
const CS_MEDIA_KIND_FULL_WIDTH = "fullWidth";
const CS_MEDIA_KIND_MEDIA_TEXT = "mediaText";

/* Pure: returns the matching cs-media element + kind, or null. */
function findCsMediaTarget(eventTarget) {
  if (!eventTarget || typeof eventTarget.closest !== "function") return null;
  const fullWidth = eventTarget.closest(".cs-full-width__media");
  if (fullWidth) return { element: fullWidth, kind: CS_MEDIA_KIND_FULL_WIDTH };
  const mediaText = eventTarget.closest(".cs-media-text__media");
  if (mediaText) return { element: mediaText, kind: CS_MEDIA_KIND_MEDIA_TEXT };
  return null;
}

/* Pure: maps a media kind to its `--touched` modifier class. */
function csTouchedClassFor(kind) {
  return kind === CS_MEDIA_KIND_FULL_WIDTH
    ? "cs-full-width__media--touched"
    : "cs-media-text__media--touched";
}

/* Impure shell: per-element timer state + DOM mutation. */
const csHideTimerByMedia = new WeakMap();

function showCsMediaThenScheduleHide(mediaElement, touchedClass) {
  mediaElement.classList.add(touchedClass);
  const previousTimer = csHideTimerByMedia.get(mediaElement);
  if (previousTimer) clearTimeout(previousTimer);
  const nextTimer = setTimeout(() => {
    mediaElement.classList.remove(touchedClass);
    csHideTimerByMedia.delete(mediaElement);
  }, CS_TOUCH_HIDE_DELAY_MS);
  csHideTimerByMedia.set(mediaElement, nextTimer);
}

document.addEventListener(
  "touchstart",
  (event) => {
    const match = findCsMediaTarget(event.target);
    if (!match) return;
    showCsMediaThenScheduleHide(match.element, csTouchedClassFor(match.kind));
    showCsMediaThenScheduleIdle(match.element);
  },
  { passive: true },
);

/* ----------------------------------------------------------------------
   Idle-hide: hide controls (and cursor) after 1s of no mouse movement /
   touch on a CS media element. Movement reveals them again. CSS limits
   the actual hide to playing videos so paused state keeps the play button.
   ---------------------------------------------------------------------- */
const CS_IDLE_HIDE_MS = 1000;

function csIdleClassFor(mediaElement) {
  if (mediaElement.classList.contains("cs-full-width__media")) {
    return "cs-full-width__media--idle";
  }
  if (mediaElement.classList.contains("cs-media-text__media")) {
    return "cs-media-text__media--idle";
  }
  return null;
}

const csIdleTimerByMedia = new WeakMap();

function showCsMediaThenScheduleIdle(mediaElement) {
  const idleClass = csIdleClassFor(mediaElement);
  if (!idleClass) return;
  mediaElement.classList.remove(idleClass);
  const previousTimer = csIdleTimerByMedia.get(mediaElement);
  if (previousTimer) clearTimeout(previousTimer);
  const nextTimer = setTimeout(() => {
    mediaElement.classList.add(idleClass);
    csIdleTimerByMedia.delete(mediaElement);
  }, CS_IDLE_HIDE_MS);
  csIdleTimerByMedia.set(mediaElement, nextTimer);
}

document.addEventListener("mousemove", (event) => {
  const match = findCsMediaTarget(event.target);
  if (!match) return;
  showCsMediaThenScheduleIdle(match.element);
});
